// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"5e681f7c","616":"5e681f7c","657":"5e681f7c","724":"5e681f7c"}[chunkId] + ".chunk.css";
};